import Character from "./characters/Character"
import { defaultStats } from "./CreatingMechanic"
import { Enemy } from "./enemies/Enemy"


export default class FightMechanic {
    private turnOrder: Character[] | Enemy[]
    private mainCharacter: Character
    private enemiesArr: Enemy[]
    private currentTurn: number
    private isNpcTurn: boolean
    private characterIndex: number
    private skillIndex: number
    private deadEnemies: number
    private isWon: boolean
    private isLose: boolean
    private isHitMissed: boolean

    private static instance: FightMechanic

    private constructor() {
        this.currentTurn = 0
        this.isNpcTurn = false
        this.characterIndex = -1
        this.skillIndex = 0
        this.deadEnemies = 0
        this.mainCharacter = new Character(defaultStats)
        this.enemiesArr = []
        this.isWon = false
        this.isLose = false
        this.isHitMissed = false
        this.turnOrder = [this.mainCharacter, ...this.enemiesArr]

        this.setIsNpcTurn()
    }

    setTurn(newTurn: number): void {
        this.currentTurn = newTurn
    }

    getTurn(): number {
        return this.currentTurn
    }

    getIsNpcTurn() {
        return this.isNpcTurn
    }

    setTurnOrder() {
        this.turnOrder = [this.mainCharacter, ...this.enemiesArr]
    }

    getOrder() {
        return this.turnOrder
    }

    getCurrentTurn() {
        return this.currentTurn
    }

    setSkillIndex(index: number) {
        this.skillIndex = index
    }

    getIsWon() {
        return this.isWon
    }

    getDeadEnemies() {
        return this.deadEnemies
    }

    getEnemiesArr() {
        return this.enemiesArr
    }

    getIsLose() {
        return this.isLose
    }

    setCharacterIndex(value: number) {
        this.characterIndex = value
    }

    getCharacterIndex() {
        return this.characterIndex
    }

    setCharacter(character: Character) {
        this.mainCharacter = character
    }

    getCharacter() {
        return this.mainCharacter
    }

    setEnemiesArr(enemies: Enemy[]) {
        this.enemiesArr = [...enemies]
    }

    // enterPoint
    doSkill() {
        if (this.skillCooldownCheck()) {
            switch (this.skillIndex) {
                case 1:
                    this.doFirstSkill()
                    break;
                case 2:
                    this.doSecondSkill()
                    break;
                case 3:
                    this.doThirdSkill()
                    break;
                case 0:
                default:
                    this.doDamage()
                    break;
            }
            this.resetDeadEnemies()
            this.enemiesArr.forEach(element => {
                if(element.getIsDead()) {
                    this.pushToDeadEnemies()
                    
                    if(!element.isLooted) {
                        this.addLoot()
                        this.addExp()
                        element.setLooted()
                    }
                }
                this.setIsWon(this.deadEnemies === this.getEnemiesArr().length)
            })
            // * передачу хода делаем в контроллере
            // this.nextTurn()
        }
    }

    private addLoot() {
        const loot = this.getEnemiesArr()[this.getCharacterIndex()].getCurensy()
        this.mainCharacter.getInventory().pushToCurrencies(loot)
    }

    private addExp() {
        const exp = this.enemiesArr[this.characterIndex].getExp()
        this.mainCharacter.addLevelExp(exp)
    }

    npcTurn() {
        // проверка жив НПЦ или нет делается в контроллере
        this.turnOrder[this.currentTurn].npcDealDamage(this.mainCharacter)
        this.setIsLose(this.mainCharacter.getHp() <= 0)

        // * проверка жив НПЦ или нет на месте
        // if (this.turnOrder[this.currentTurn].getHp() > 0) {

        //     this.turnOrder[this.currentTurn].npcDealDamage(this.mainCharacter)
        //     this.setIsLose(this.mainCharacter.getHp() <= 0)

        //     // ? промис для "пошаговости"
        //     // const promice = new Promise<void>((resolve) => {
        //     //     setTimeout(() => {
        //     //         resolve()
        //     //     }, 3000);
        //     // })
        //     // promice.then(() => {
        //     //     this.turnOrder[this.currentTurn].npcDealDamage(this.mainCharacter)
        //     //     this.setIsLose(this.mainCharacter.getHp() <= 0)
        //     // })
        // }
        // else {
        //     this.nextTurn()
        // }
    }

    getSkillIndex() {
        return this.skillIndex
    }

    nextTurn() {
        if (this.getIsWon() || this.getIsLose())
            return
        if (this.getTurn() < this.getOrder().length - 1)
            this.setTurn(this.getCurrentTurn() + 1)
        else
            this.setTurn(0)

        // * выдаёт ошибку, нужно разбиратся
        // this.doConditions(this.turnOrder[this.currentTurn])
        this.setIsNpcTurn()
        if (this.getIsNpcTurn()) {
            // * передачу хода делаем в контроллере
            // this.npcTurn()
        }
    }

    private doDamage() {
        this.mainCharacter.dealDamage(this.getEnemiesArr()[this.getCharacterIndex()])
    }

    private doFirstSkill() {
        this.mainCharacter.firstSkill(this.enemiesArr, this.characterIndex)
    }

    private doSecondSkill() {
        this.mainCharacter.secondSkill(this.enemiesArr, this.characterIndex)
    }

    private doThirdSkill() {
        this.mainCharacter.thirdSkill(this.enemiesArr, this.characterIndex)
    }

    private skillCooldownCheck() {
        const currentCharacter = this.mainCharacter
        if (currentCharacter.getskillsCooldown()[this.getSkillIndex()] > 0)
            return false
        return true
    }

    private pushToDeadEnemies() {
        this.deadEnemies++
    }

    private resetDeadEnemies() {
        this.deadEnemies = 0
    }

    private setIsNpcTurn(): void {
        const character = this.turnOrder[this.currentTurn]
        if (character) this.isNpcTurn = character.getIsNpc()
    }

    private setIsWon(value: boolean) {
        this.isWon = value
    }

    private setIsLose(value: boolean) {
        this.isLose = value
    }

    private doConditions(character: Character | Enemy) {
        const conditions = character.getConditions()
        for (let i = 0; i < conditions.length; i++) {
            switch (conditions[i].name) {
                case "bleeding":
                    character.setHp(character.getHp() - conditions[i].damage)
                    conditions[i].duration--
                    break;
                case "poison":
                    character.setHp(character.getHp() - conditions[i].damage)
                    conditions[i].duration--
                    break;
                case "stun":
                    this.nextTurn()
                    conditions[i].duration--
                    break;
                default:
                    character.setHp(character.getHp() - conditions[i].damage)
                    conditions[i].duration--
                    break;
            }
        }
    }

    reset() {
        this.turnOrder = []
        this.currentTurn = 0
        this.isNpcTurn = false
        this.characterIndex = -1
        this.skillIndex = 0
        this.deadEnemies = 0
        this.mainCharacter = new Character(defaultStats)
        this.enemiesArr = []
        this.isWon = false
        this.isLose = false
        this.isHitMissed = false

        this.setIsNpcTurn()
    }

    public static getInstance() {
        if (!FightMechanic.instance)
            FightMechanic.instance = new FightMechanic()

        return FightMechanic.instance
    }
}
